import { computed } from "vue";
import { INTAKE_STAGE } from "@/models/intakeStatus";
import { intakeService } from "@/services/intakeService";
const WRITABLE_STAGES = [
    INTAKE_STAGE.QUALIFY_PATIENT,
    INTAKE_STAGE.CLINICAL_REVIEW,
    INTAKE_STAGE.PRIOR_AUTHORIZATION,
    INTAKE_STAGE.DENIAL_FOLLOWUP,
    INTAKE_STAGE.APPROVED,
];
/** The benefits card on an intake step page: card prefill, the stages the backend saves at, the refresh after a save. */
export function useIntakeBenefitsCard(options) {
    const benefitsPrefill = computed(() => {
        const card = options.insuranceCard();
        return card ? { payerName: card.payorName || "", memberId: card.memberId || "" } : null;
    });
    const benefitsWritable = computed(() => WRITABLE_STAGES.includes(options.order()?.status ?? ""));
    const onBenefitsChanged = async () => {
        const orderId = options.orderId();
        const order = options.order();
        try {
            const refreshed = await intakeService.getIntakeOrder(orderId);
            if (order)
                order.statusTags = refreshed.statusTags || [];
            options.onRefreshed();
        }
        catch {
            options.onError("Benefits were saved, but the order could not be refreshed. Reload the page to see its tags.");
        }
    };
    return { benefitsPrefill, benefitsWritable, onBenefitsChanged };
}
